import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const Available = ({ onSync, syncing }: { onSync: () => void; syncing: boolean }) => {
  return (
    <>
      <Text.Header2>
        {i18n.t('payroll_integrations.incidences.silae_api.leave.available.title')}
      </Text.Header2>
      <Box>{i18n.t('payroll_integrations.incidences.silae_api.leave.available.message')}</Box>
      <Button onClick={onSync} disabled={syncing}>
        {i18n.t('payroll_integrations.incidences.silae_api.leave.available.submit')}
      </Button>
    </>
  )
}

export default Available
